import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconEditor = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M50.368 1.893c-2.294.186-4.415.99-6.107 2.314-.62.485-37.584 37.433-37.73 37.713-.064.123-1.134 4.184-2.377 9.024-1.818 7.078-2.26 8.881-2.262 9.216-.003.759.447 1.44 1.18 1.783.675.317.294.397 9.984-2.095 4.84-1.245 8.9-2.315 9.024-2.38.28-.144 37.227-37.108 37.713-37.729 1.657-2.116 2.514-4.97 2.29-7.628-.23-2.73-1.314-5.091-3.208-6.986a11 11 0 0 0-5.211-2.938c-.904-.223-2.458-.362-3.296-.294m-.51 4.096c-1.19.217-2.483.806-3.266 1.488l-.224.195 4.96 4.964c2.728 2.73 4.98 4.964 5.006 4.964.095 0 .691-.86.969-1.397a7.06 7.06 0 0 0-3.127-9.596c-1.227-.613-2.973-.863-4.318-.618m-7.539 5.676c-.642.642-1.167 1.197-1.167 1.232 0 .083 9.87 9.951 9.953 9.951.035 0 .597-.533 1.247-1.184l1.183-1.184-4.991-4.992c-2.745-2.746-5.006-4.992-5.024-4.992-.019 0-.559.526-1.2 1.169M24.688 29.296 11.136 42.848l5.008 5.008 5.008 5.008L34.72 39.296l13.568-13.568-4.992-4.992c-2.745-2.746-5.006-4.992-5.024-4.992s-6.13 6.098-13.584 13.552M8.016 52.051a593 593 0 0 0-1.338 5.271c.03.03 10.538-2.695 10.538-2.733 0-.024-1.767-1.79-3.926-3.922L9.365 46.79z" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconEditor.displayName = 'IconEditor';